import { Button, DatePicker, Drawer, Form, Input, Radio } from "antd";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  loadSingleExpenseForm,
  reviewExpenseForm,
} from "../../../redux/rtk/features/expense/expenseSlice";
import getUserFromToken from "../../../utils/getUserFromToken";
import moment from "moment";

const ReviewExpensePopup = () => {
  const { id } = useParams("id");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const data = useSelector((state) => state.expense.expense);
  const userId = getUserFromToken();
  const [status, setStatus] = useState(null);

  const [initialValues, setInitialValues] = useState({
    // expenseAmount: data?.expenseAmount,
    // userId: userId,
    // status: data?.approvalStatus,
  });

  useEffect(() => {
    // console.log("expensePopup loading Data", data);
    setInitialValues({
      ...data,
      user_id: userId,
      status: data?.approvalStatus,
      expenseAmount: data?.expenseAmount,
	  credit_id: 2,
	  debit_id: 15
      // acceptLeaveTo: moment(data?.leaveTo),
    });
  }, [data]);

  const onFinish = async (values) => {
    const FormData = {
      ...values,
	  credit_id: 2,
	  debit_id: 15,
      user_id: userId,
    };
    const resp = await dispatch(
      reviewExpenseForm({ id: id, values: FormData })
    );

    if (resp.payload.message === "success") {
      setOpen(false);
      dispatch(loadSingleExpenseForm(id));
      setLoader(false);
      setStatus(null);
    } else {
      setLoader(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at expense operation");
    setLoader(false);
  };
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    setStatus(null);
  };

  return (
    <>
      <Button onClick={showDrawer} className="mt-4" type="primary">
        Review Expense
      </Button>
      {data && (
        <Drawer
          width={720}
          title="Expense Review"
          placement="right"
          onClose={onClose}
          open={open}
        >
          <h2 className="text-2xl font-semibold mb-4 text-center mt-5">
            Approve Expense
          </h2>
          <Form
            className="list-inside list-none border-2 border-inherit rounded px-5 py-5 m-5 mt-10"
            form={form}
            style={{ marginBottom: "40px" }}
            name="basic"
            initialValues={initialValues}
            labelCol={{
              span: 7,
            }}
            wrapperCol={{
              span: 12,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div>
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Expense Amount"
                name="expenseAmount"
              >
                <Input name="expenseAmount" readOnly />
                {/* // rules={[
								// 	{
								// 		required: true,
								// 		message: "Please input Date !",
								// 	},
								// ]} */}

                {/* <DatePicker format={"DD-MM-YYYY"} /> */}
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Approved Amount"
                name="approvedAmount"
                rules={[
                  {
                    required: true,
                    message: "Please input Approved Amount!",
                  },
                  {
                    pattern: /^(\d+|\d+\.\d{1,2})$/,
                    message:
                      "Please enter a valid number (integer or decimal with up to 2 decimal places)!",
                  },
                ]}
              >
                <Input name="approvedAmount" />
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Comment"
                name="reviewComment"
              >
                <Input name="reviewComment" />
              </Form.Item>

              {status === null && (
                <p className="text-red-500 text-center mb-3">
                  Please select status
                </p>
              )}

              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Select Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please input Status!",
                  },
                ]}
              >
                <Radio.Group
                  buttonStyle="solid"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <Radio.Button value="APPROVED">APPROVED</Radio.Button>
                  <Radio.Button value="REJECTED">REJECTED</Radio.Button>
                  <Radio.Button value="PARTIAL APPROVED">PARTIAL APPROVED</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{
                  offset: 7,
                  span: 12,
                }}
              >
                <Button
                  onClick={() => setLoader(true)}
                  type="primary"
                  size="middle"
                  htmlType="submit"
                  block
                  disabled={status === null}
                  loading={loader}
                >
                  Review Expense
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Drawer>
      )}
    </>
  );
};
export default ReviewExpensePopup;
